export default "__VITE_ASSET__bd4f6ef5__"